import styled from 'styled-components';
import { s8 } from '@ardoq/design-tokens';

export const ViewLegendItem = styled.div`
  display: flex;

  &:not(:first-child) {
    margin-top: ${s8};
  }

  .forExport & {
    flex-direction: row;
    max-height: unset;
    width: 100%;
  }
`;
